// Simple Quantity Buttons with Max Inventory Check
// Basic plus/minus with inventory limits - Scoped to individual product cards

console.log('🔧 Quantity Buttons JS Loaded');

// B2B quantity rules: inputs may carry data-min / data-inc / data-max (from variant.quantity_rule).
// Returns the rule plus the largest valid quantity allowed by stock and the rule max.
function fdpQtyRule(input) {
    const min = parseInt(input.dataset.min) || 1;
    const inc = parseInt(input.dataset.inc) || 1;
    let max = parseInt(input.dataset.inventoryQuantity) || 999;
    const ruleMax = parseInt(input.dataset.max);
    if (ruleMax && ruleMax < max) max = ruleMax;
    // Snap the cap down to a valid step (min + n*inc)
    const validMax = max >= min ? max - ((max - min) % inc) : min;
    return { min, inc, max: validMax };
}

// Snap a value onto the rule: at least min, on a valid step, not above the cap.
function fdpSnapQty(value, rule) {
    let v = parseInt(value) || rule.min;
    if (v < rule.min) v = rule.min;
    const over = (v - rule.min) % rule.inc;
    if (over !== 0) v += rule.inc - over;
    if (v > rule.max) v = rule.max;
    return v;
}


document.addEventListener('DOMContentLoaded', function() {
    console.log('📦 DOM Content Loaded - Initializing Quantity Buttons');

    // Simple event delegation for all quantity buttons
    document.addEventListener('click', function(event) {
        const button = event.target.closest('.btn-quantity');
        if (!button) return;

        console.log('🔘 Button clicked:', button.className, button.name);
        event.preventDefault();

        // Find the product card/item container first (try multiple selectors)
        const productCard = button.closest('.product-item, .card, [data-product-item], [data-product-card], form.variants, [data-product-id]');
        console.log('🏷️ Found product card:', productCard);

        if (!productCard) {
            console.error('❌ No product card container found');
            return;
        }

        // Then find the quantity input within this specific product card
        const input = productCard.querySelector('input[name="quantity"], input.quantity');
        //console.log('📝 Found input:', input);

        if (!input) {
            console.error('❌ No quantity input found in product card');
            return;
        }

        const rule = fdpQtyRule(input);
        let currentValue = parseInt(input.value) || rule.min;

        console.log('📊 Current value:', currentValue, 'Rule:', rule);

        // Plus/minus step by the rule increment, within min and the stock/rule cap
        if (button.classList.contains('plus') || button.name === 'plus') {
            if (currentValue + rule.inc <= rule.max) {
                currentValue = fdpSnapQty(currentValue + rule.inc, rule);
                console.log('➕ Increased to:', currentValue);
            } else {
                showSimpleWarning(`Maximum quantity is ${rule.max}`);
                console.log('🚫 Hit max limit');
                return;
            }
        } else if (button.classList.contains('minus') || button.name === 'minus') {
            currentValue = fdpSnapQty(Math.max(rule.min, currentValue - rule.inc), rule);
            console.log('➖ Decreased to:', currentValue);
        }

        // Update the input value
        input.value = currentValue;
        console.log('💾 Updated input value to:', currentValue);

        // Dispatch change event for any other listeners
        input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    // While typing, only cap the top (snapping every keystroke would fight multi-digit entry)
    document.addEventListener('input', function(event) {
        const input = event.target;
        if (input.name === 'quantity' || input.classList.contains('quantity')) {
            if (input.closest('.coll-case-only')) return; // case-only list has its own handler
            const rule = fdpQtyRule(input);
            const value = parseInt(input.value);
            if (value > rule.max) {
                input.value = rule.max;
                showSimpleWarning(`Maximum quantity is ${rule.max}`);
            }
        }
    });

    // On commit, snap to min / increment / max
    document.addEventListener('change', function(event) {
        const input = event.target;
        if (input.name === 'quantity' || input.classList.contains('quantity')) {
            if (input.closest('.coll-case-only')) return;
            const rule = fdpQtyRule(input);
            const snapped = fdpSnapQty(input.value, rule);
            if (String(snapped) !== input.value) input.value = snapped;
        }
    });
});

// Simple warning function
function showSimpleWarning(message) {
    // Try to use existing warning system if available
    if (typeof showWarning === 'function') {
        showWarning(message, 3000);
    } else {
        // Fallback: simple alert or console log
        console.log('Quantity Warning:', message);
        // You can replace this with a custom notification system
        // alert(message);
    }
}

// Fallback initialization
window.addEventListener('load', function() {
    // Re-run the event listeners in case DOM was modified after initial load
    const quantityButtons = document.querySelectorAll('.btn-quantity');
    quantityButtons.forEach(button => {
        if (!button.hasAttribute('data-initialized')) {
            button.setAttribute('data-initialized', 'true');
        }
    });
});
